import React from "react";
import { OutlinedTextFieldProps, TextField } from "@mui/material";

export interface SimpleFormTextFieldProps extends Omit<OutlinedTextFieldProps, ('variant' | 'fullWidth')> {
}

export default function SimpleFormTextField(props: SimpleFormTextFieldProps) {
  return (
    <TextField
        fullWidth
        autoComplete="off"
        type={props.type || "text"}
        sx={{ marginBottom:"15px" }}
        variant="outlined"
        value={props.value}
        onChange={props.onChange}
        {...props}
      />
  );
}
